import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {Permission} from 'common/report/constants';
import {excludeDemos, getWorkspaceId} from 'common/report/util';
import {WorkspaceObj} from 'common/report/queries/app-api/workspaces-client';
import {findCurrentValidWorkspaceId, getWorkspacesForCurrentProject, sortWorkspaces} from 'common/util/workspaces';
import type {ProjectsResource} from 'common/report/model-resources/projects';
import {isProjectOnlyApp} from 'common/report/util/state-from-url';
import {Organization} from 'common/report/queries/app-api/user-metadata-client';

export {findCurrentValidWorkspaceId, getWorkspacesForCurrentProject};

export function getWorkspacesForProject({
  projectsResource,
  currentProject,
  projectId,
}: {
  projectsResource?: ProjectsResource;
  currentProject?: CurrentProject;
  projectId: number;
}): WorkspaceObj[] {
  const project = projectId === currentProject?.id ? currentProject : projectsResource?.getOne(projectId).value;
  return Object.values(project?.workspaces ?? {}).sort(sortWorkspaces);
}

export function getCurrentWorkspaceId({
  currentProject,
  reportEndpoint,
}: {
  currentProject?: CurrentProject;
  reportEndpoint?: string;
}): number | undefined {
  // rely on the url for the current workspace id
  let currentWorkspaceId = parseInt(getWorkspaceId(), 10) || undefined; // undefined instead of NaN

  if (!currentWorkspaceId && isProjectOnlyApp(reportEndpoint)) {
    // project only apps (e.g. settings, data views) never have the workspace id in the url; for these apps we add
    // this special logic to obtain a valid workspace id from outside the url
    currentWorkspaceId = findCurrentValidWorkspaceId({currentProject, firstPriorityWorkspaceId: currentWorkspaceId});
  }

  return currentWorkspaceId;
}

export function getFilteredOrgs(
  organizations: Record<string, Organization>,
  {permissions, excludeDemoOrgs = false}: {permissions?: Permission[]; excludeDemoOrgs?: boolean},
) {
  let orgList = Object.values(organizations);
  if (permissions) {
    orgList = orgList.filter((o) => permissions.every((p) => o.permissions && o.permissions.includes(p)));
  }
  if (excludeDemoOrgs) {
    orgList = excludeDemos(orgList);
  }
  return orgList;
}
